import React from 'react';
import { motion } from 'framer-motion';
import { Store, Play } from 'lucide-react';

const VendorsHero: React.FC = () => {
  const onboardingSteps = [
    "Create your vendor account",
    "Upload product catalog and pricing", 
    "Set up delivery zones and timing",
    "Configure payment details",
    "Start receiving orders instantly"
  ];

  return (
    <section className="pt-32 pb-20 bg-gradient-to-br from-white via-gray-50 to-red-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-r from-red-200 to-orange-200 rounded-full opacity-10 blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <motion.div 
            className="inline-flex items-center gap-2 bg-gradient-to-r from-red-50 to-orange-50 text-red-500 rounded-2xl px-4 py-2 mb-6"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Store size={20} />
            <span className="font-semibold text-sm">Dailzy Saathi - Vendor Onboarding Platform</span>
          </motion.div>
          
          <motion.h1 
            className="text-5xl lg:text-6xl font-bold text-gray-800 mb-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <span className="bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
              Dailzy Saathi
            </span>
            <br />
            Vendor Onboarding Platform
          </motion.h1>
        </div>

        {/* Onboarding Video Section */}
        <motion.div 
          className="max-w-7xl mx-auto mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {/* <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Onboarding made simple Video</h2>
          </div> */}
          
          <div className="grid md:grid-cols-3 gap-12 items-center">
            {/* Video Section */}
            <motion.div 
              className="order-2 md:order-1 md:col-span-2"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <div className="relative bg-gray-200 rounded-3xl overflow-hidden shadow-2xl aspect-video">
                <div className="absolute inset-0 flex items-center justify-center">
                  <motion.button
                    className="w-20 h-20 bg-red-500 rounded-full flex items-center justify-center shadow-lg hover:bg-red-600 transition-colors"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Play className="w-8 h-8 text-white ml-1" fill="currentColor" />
                  </motion.button>
                </div>
              </div>
            </motion.div>

            {/* Onboarding Steps */}
            <motion.div 
              className="order-1 md:order-2 md:col-span-1"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="flex flex-col space-y-6">
                {onboardingSteps.map((step, index) => (
                  <motion.div
                    key={index}
                    className="flex items-center space-x-4"
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 shadow-md">
                      <span className="text-white text-sm font-bold">{index + 1}</span>
                    </div>
                    <div className="flex-1">
                      <span className="text-gray-700 font-medium">{step}</span>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VendorsHero; 